<template>
  <div style="margin: 0px 30px" class="report-15" dir="ltr">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <div class="mlogo t-alignlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>

    <h3 class="text-center">{{ allData.fullName }}</h3>
    <h3 class="text-center">{{ allData.shortName }}</h3>
    <h3 class="text-center">شهادة المرتب</h3>

    <div class="md-layout-item md-size-120">
      <h4 style="margin-left: 120px; text-align: left">
        التاريخ : {{ convert(date) }}
      </h4>

      <h4 style="margin-left: 100px; text-align: left">: الرقم الإشاري</h4>
    </div>

    <div style="direction: rtl; margin-top: 50px" class="md-layout">
      <div class="md-layout-item md-size-60" style="min-width: 60% !important">
        <h3 class="text-left bord" style="margin-right: 70px">
          الإسم : <span style="margin-right: 10px"></span>
          {{ allData.employeeName }}
        </h3>
      </div>

      <div class="md-layout-item md-size-30">
        <h3 class="text-left bord">
          الرقم الوطني : <span style="margin-right: 10px"></span>
          {{ allData.nationalNumber }}
        </h3>
      </div>
    </div>

    <div style="direction: rtl; margin-top: 0px" class="md-layout">
      <div class="md-layout-item md-size-30">
        <h3 style="margin-right: 70px" class="text-left bord">
          رقم الموظف : <span style="margin-right: 10px"></span>
          {{ allData.jobNumber }}
        </h3>
      </div>

      <div class="md-layout-item md-size-30">
        <h3 class="text-left bord">
          الدرجة الوظيفية : <span style="margin-right: 10px"></span>
          {{ allData.degree }}
        </h3>
      </div>

      <div class="md-layout-item md-size-30">
        <h3 class="text-left bord">
          العلاوة : <span style="margin-right: 10px"></span>
          {{ allData.bonuse }}
        </h3>
      </div>
    </div>

    <div style="direction: rtl; margin-top: 0px" class="md-layout">
      <div class="md-layout-item md-size-30">
        <h3 style="margin-right: 70px" class="text-left bord">
          المصرف : <span style="margin-right: 10px"></span>
          {{ allData.bankBranchName }}
        </h3>
      </div>

      <div class="md-layout-item md-size-30">
        <h3 class="text-left bord">
          رقم الحساب : <span style="margin-right: 10px"></span>
          {{ allData.accountNumber }}
        </h3>
      </div>

      <div class="md-layout-item md-size-30">
        <h3 class="text-left bord">
          الوظيفة : <span style="margin-right: 10px"></span>
          {{ allData.job }}
        </h3>
      </div>
    </div>

    <div style="display: flex; margin-right: 70px; flex-direction: row-reverse">
      <section style="width: 550px" class="body">
        <div style="margin-top: 50px" class="first-section">
          <div class="right">
            <div style="background: #f4f4f4" class="t-body">
              <p>بيان الإضافة<span class="mr-13"></span></p>
              <p>القيمة<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>المرتب الأساسي <span class="mr-13"></span></p>
              <p>{{ allData.basicSalary }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>علاوة طبيعة العمل <span class="mr-13"></span></p>
              <p>{{ allData.allownaces }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>الإجمالي <span class="mr-13"></span></p>
              <p>{{ allData.totalSalary }}<span class="mr-13"></span></p>
            </div>
          </div>
        </div>
      </section>

      <section style="width: 550px; margin-right: 100px" class="body">
        <div style="margin-top: 50px" class="first-section">
          <div class="right">
            <div style="background: #f4f4f4" class="t-body">
              <p>بيان الإستقطاع<span class="mr-13"></span></p>
              <p>القيمة<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>الإشتراكات الضمانية <span class="mr-13"></span></p>
              <p>{{ allData.warrantyTax }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>حصة التضامن <span class="mr-13"></span></p>
              <p>{{ allData.solidarityTax }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p style="width: 40% !important">
                خصميات اخرى <span class="mr-13"></span>
              </p>
              <p>{{ allData.otherDiscounts }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>ضريبة الجهاد <span class="mr-13"></span></p>
              <p>{{ allData.jihadTax }}<span class="mr-13"></span></p>
            </div>

            <div class="t-body">
              <p>الإجمالي <span class="mr-13"></span></p>
              <p>{{ allData.totalDiscount }}<span class="mr-13"></span></p>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div style="direction: rtl; margin-top: 50px" class="md-layout">
      <div class="md-layout-item md-size-65">
        <h3
          class="text-left bord"
          style="background: #f4f4f4; margin-right: 70px"
        >
          الصافي بالحروف : <span style="margin-right: 10px"></span>
          {{ allData.netSalaryString }}
        </h3>
      </div>

      <div class="md-layout-item md-size-25">
        <h3
          style="background: #f4f4f4; margin-right: 10px"
          class="text-left bord"
        >
          صافي المرتب : <span style="margin-right: 10px"></span>
          {{ allData.netSalary }}
        </h3>
      </div>
    </div>

    <div
      class="bord"
      style="
        background: #f4f4f4;
        margin-top: 50px;
        margin-right: 70px;
        margin-left: 100px;
      "
    >
      <div style="direction: rtl" class="md-layout">
        <div style="text-align: center" class="md-layout-item md-size-100">
          <h4>
            أعطيت هذه الشهادة بناء على طلبه لاستعمالها في الأغراض المسموح بها
            قانونا
          </h4>
        </div>
      </div>

      <div class="md-layout mt-25 text-center">
        <div style="text-align: start" class="md-layout-item md-size-40">
          <p style="font-weight: bold">يعتمد رئيس قسم الشؤون المالية</p>
          <p style="font-weight: bold; margin-left: 158px">: التوقيع</p>
        </div>

        <div class="md-layout-item md-size-40" style="text-align: end">
          <p style="font-weight: bold">معد الشهادة</p>
          <p style="font-weight: bold">: الإسم</p>
          <p style="font-weight: bold">: التوقيع</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: ["allData", "date", "pathLogo"],
  data() {
    return {
      m: env.mTop(),
    };
  },

  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getMonth() + 1 + "-" + d.getFullYear()
          // + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/employeeCard";

.bord {
  border: 1px solid #000;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 14px;
}

.t-body {
  direction: rtl;
}
</style>

